export const Measure = props => {
  return (
    <svg
      width="41"
      height="25"
      viewBox="0 0 41 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1 0.5L1 14.5" stroke="currentColor" strokeLinecap="round" />
      <line x1="40.5" y1="1" x2="40.5" y2="14" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M3.64645 7.14645C3.45118 7.34171 3.45118 7.65829 3.64645 7.85355L6.82843 11.0355C7.02369 11.2308 7.34027 11.2308 7.53553 11.0355C7.7308 10.8403 7.7308 10.5237 7.53553 10.3284L4.70711 7.5L7.53553 4.67157C7.7308 4.47631 7.7308 4.15973 7.53553 3.96447C7.34027 3.7692 7.02369 3.7692 6.82843 3.96447L3.64645 7.14645ZM38.3536 7.85355C38.5488 7.65829 38.5488 7.34171 38.3536 7.14645L35.1716 3.96447C34.9763 3.7692 34.6597 3.7692 34.4645 3.96447C34.2692 4.15973 34.2692 4.47631 34.4645 4.67157L37.2929 7.5L34.4645 10.3284C34.2692 10.5237 34.2692 10.8403 34.4645 11.0355C34.6597 11.2308 34.9763 11.2308 35.1716 11.0355L38.3536 7.85355ZM4 7.5V8L38 8V7.5V7L4 7V7.5Z"
        fill="currentColor"
      />
      <rect x="0.5" y="17" width="40" height="7" rx="0.5" stroke="currentColor" />
      <line x1="20.5" y1="17.5" x2="20.5" y2="21.5" stroke="currentColor" />
      <line x1="30.5" y1="17.5" x2="30.5" y2="21.5" stroke="currentColor" />
      <line x1="5.5" y1="16.5" x2="5.5" y2="19.5" stroke="currentColor" />
      <line x1="15.5" y1="16.5" x2="15.5" y2="19.5" stroke="currentColor" />
      <line x1="35.5" y1="17.5" x2="35.5" y2="20.5" stroke="currentColor" />
      <line x1="25.5" y1="17.5" x2="25.5" y2="20.5" stroke="currentColor" />
      <line x1="10.5" y1="17.5" x2="10.5" y2="21.5" stroke="currentColor" />
    </svg>
  );
};
